/**
 * /tracking/api-tracking — operator console for API-based tracking (feature #160).
 *
 * Flat-file TanStack route: dots become path separators, so
 * `tracking.api-tracking.tsx` maps to `/tracking/api-tracking`. The route
 * hosts the `ApiTrackingPage` which drives the `/api/v1/api-tracking/click`
 * and `/api/v1/api-tracking/convert` endpoints via a two-panel form.
 *
 * Mirrors the shape of the other flat routes (advertisers.caps.tsx,
 * publishers.tracking-domains.tsx) so the central wire-up picks this up
 * through the same pattern.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { ApiTrackingPage } from "@/features/api-tracking/ApiTrackingPage";

// ---------------------------------------------------------------------------
// Route declaration.
// ---------------------------------------------------------------------------

export const trackingApiTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/api-tracking",
	component: TrackingApiTrackingRoute,
});

export default trackingApiTrackingRoute;

function TrackingApiTrackingRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-5xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">API-based tracking</li>
				</ol>
			</nav>

			<ApiTrackingPage />
		</div>
	);
}

// Named export so the registry wire-up can import the page directly.
export { ApiTrackingPage } from "@/features/api-tracking/ApiTrackingPage";
